import { api } from "../http/index";
import { AxiosResponse } from "axios";
import { CasinoGameType } from "../common/types/Casino/CasinoGameType";
import { GameProvider } from "../common/types/Casino/GameProvider";
import { login } from "../common/types/Auth/login";
import { UserInformation } from "../common/types/AdminInfo/UserInformation";
import { userDeposit } from "../common/types/AdminInfo/userDeposit";
import { userPay, userPayBody } from "../common/types/AdminInfo/userPay";
import { userBalanceType } from "../common/types/AdminInfo/userBalanceType";
import { userBets } from "../common/types/AdminInfo/userBets";
import { register } from "../common/types/Auth/register";
import { changePassword } from "../common/types/Auth/changePassword";
import { FavoritCasinoResponceType } from "../common/types/Casino/FavoritCasinoResponceType";
import { LastWinnersReguestType } from "../common/types/Casino/LastWinnerType";
import { BannersListType } from "../common/types/Casino/BannersListType";

const token = process.env.REACT_APP_API_ORIGIN_TOKEN;

class AuthService {
  static async login({
    username,
    password,
  }: login): Promise<AxiosResponse<string>> {
    // const token = "3|NVOjwwPJpi2XmtJ9NnYqkPKpBvv5lXxFFftY9nnC";

    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    return api.post<string>("api/login", { username, password });
  }
  static async register({
    address,
    affid,
    birthday,
    country,
    currency,
    cxd,
    email,
    firstname,
    gender,
    language,
    lastname,
    passport,
    password,
    password_confirmation,
    phone,
    promocode,
    state,
    username,
    zipcode,
  }: register): Promise<AxiosResponse<string>> {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    return api.post<string>("api/register", {
      address,
      affid,
      birthday,
      country,
      currency,
      cxd,
      email,
      firstname,
      gender,
      language,
      lastname,
      passport,
      password,
      password_confirmation,
      phone,
      promocode,
      state,
      username,
      zipcode,
    });
  }
  static async changePassword({
    current_password,
    password,
    password_confirmation,
  }: changePassword): Promise<AxiosResponse<string>> {
    const bearerToken = localStorage.getItem("token");
    const headers = bearerToken
      ? { Authorization: `Bearer ${bearerToken}` }
      : undefined;

    return api.post<string>(
      "/api/change-password",
      {
        current_password,
        password,
        password_confirmation,
      },
      {
        headers,
      }
    );
  }
}

class CasinoInfo {
  static async providers(
    searchParams?: string
  ): Promise<AxiosResponse<GameProvider>> {
    const bearerToken = localStorage.getItem("token");
    const headers = bearerToken
      ? { Authorization: `Bearer ${bearerToken}` }
      : undefined;
    return api.get<GameProvider>(`/providers${searchParams}`, { headers });
  }

  static async categories(searchParams: string): Promise<AxiosResponse<any>> {
    const bearerToken = localStorage.getItem("token");
    const headers = bearerToken
      ? { Authorization: `Bearer ${bearerToken}` }
      : undefined;
    return api.get<any>(`/categories-with-games${searchParams}`, { headers });
  }

  static async games(searchParams: string): Promise<AxiosResponse<any>> {
    const bearerToken = localStorage.getItem("token");
    const headers = bearerToken
      ? { Authorization: `Bearer ${bearerToken}` }
      : undefined;
    return api.get<any>(`/category-with-games${searchParams}`, { headers });
  }

  static async searchGames(searchParams: string): Promise<AxiosResponse<any>> {
    const bearerToken = localStorage.getItem("token");
    const headers = bearerToken
      ? { Authorization: `Bearer ${bearerToken}` }
      : undefined;
    return api.get<any>(`/search-games${searchParams}`, { headers });
  }
  static async setFavoritGame(data: {
    game_id: number;
    type: number;
  }): Promise<AxiosResponse<FavoritCasinoResponceType>> {
    const bearerToken = localStorage.getItem("token");
    const headers = bearerToken
      ? { Authorization: `Bearer ${bearerToken}` }
      : undefined;

    return api.post<FavoritCasinoResponceType>(`api/add-to-favorite`, data, {
      headers,
    });
  }
  static async favoritGames(): Promise<
    AxiosResponse<FavoritCasinoResponceType[]>
  > {
    const bearerToken = localStorage.getItem("token");
    const headers = bearerToken
      ? { Authorization: `Bearer ${bearerToken}` }
      : undefined;
    return api.get<FavoritCasinoResponceType[]>(`/api/favorites-games`, {
      headers,
    });
  }
  static async casinoPlay(
    searchParams: string
  ): Promise<AxiosResponse<CasinoGameType>> {
    const bearerToken = localStorage.getItem("token");
    const headers = bearerToken
      ? { Authorization: `Bearer ${bearerToken}` }
      : undefined;
    return api.get<CasinoGameType>(`/casino${searchParams}`, { headers });
  }
  static async lastWinners(): Promise<AxiosResponse<LastWinnersReguestType>> {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    return api.post<LastWinnersReguestType>("/api/last-winners");
  }
  static async MainBanners(): Promise<AxiosResponse<BannersListType>> {
    return api.get<BannersListType>("/banners");
  }
}

class AdminPanel {
  static async userInfo(): Promise<AxiosResponse<UserInformation>> {
    const bearerToken = localStorage.getItem("token");
    const headers = bearerToken
      ? { Authorization: `Bearer ${bearerToken}` }
      : undefined;
    return api.post<UserInformation>("/api/user", { headers });
  }

  static async userBalance(): Promise<AxiosResponse<userBalanceType>> {
    const bearerToken = localStorage.getItem("token");
    const headers = bearerToken
      ? { Authorization: `Bearer ${bearerToken}` }
      : undefined;
    return api.get<userBalanceType>("/api/update-user-balance", { headers });
  }
  static async userBets(params: string): Promise<AxiosResponse<userBets>> {
    const bearerToken = localStorage.getItem("token");
    const headers = bearerToken
      ? { Authorization: `Bearer ${bearerToken}` }
      : undefined;
    return api.get<userBets>(`/user-dashboard/get-all-bets${params}`, {
      headers,
    });
  }
  static async userDeposit(
    params: string
  ): Promise<AxiosResponse<userDeposit[]>> {
    const bearerToken = localStorage.getItem("token");
    const headers = bearerToken
      ? { Authorization: `Bearer ${bearerToken}` }
      : undefined;
    return api.get<userDeposit[]>(`/payment-methods${params}`, {
      headers,
    });
  }
  static async userPay({
    data,
    params,
  }: {
    data: userPay;
    params: string;
  }): Promise<AxiosResponse<userPayBody>> {
    const bearerToken = localStorage.getItem("token");
    const headers = bearerToken
      ? { Authorization: `Bearer ${bearerToken}` }
      : undefined;

    return api.post<userPayBody>(
      `/api/user-dashboard/set-deposit${params}`,
      data,
      {
        headers,
      }
    );
  }
  static async userPayManual({
    data,
    params,
  }: {
    data: userPay;
    params: string;
  }): Promise<AxiosResponse<userPayBody>> {
    const bearerToken = localStorage.getItem("token");
    const headers = bearerToken
      ? { Authorization: `Bearer ${bearerToken}` }
      : undefined;

    return api.post<userPayBody>(
      `/api/user-dashboard/set-manual-deposit${params}`,
      data,
      {
        headers,
      }
    );
  }
}

export { AuthService, CasinoInfo, AdminPanel };
